/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_ForbiddenInputs */

const id_reseller_pricing_forbidden = /** @type {(inputs: Reseller_Pricing_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya owner atau admin yang dapat mengubah harga domain.`)
};

const en_reseller_pricing_forbidden = /** @type {(inputs: Reseller_Pricing_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only an owner or an admin can change domain pricing.`)
};

/**
* | output |
* | --- |
* | "Only an owner or an admin can change domain pricing." |
*
* @param {Reseller_Pricing_ForbiddenInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_forbidden = /** @type {((inputs?: Reseller_Pricing_ForbiddenInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_ForbiddenInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_forbidden(inputs)
	return id_reseller_pricing_forbidden(inputs)
});